import { MyRequests } from './widgets';

export const TravelMyRequestsPage = () => {
  return <MyRequests />;
};
